module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/mlb/stolen-base-fd04a9630f3b96dcec23c7ba3fcf3ce9.svg";